import { makeStyles, Theme } from '@material-ui/core/styles'
import { GLOBAL_TOP_BAR_HEIGHT } from '../../../../constants'
/**
 * Styles for LeaseAuditDetail component
 */
export const useScheduleModalStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'absolute',
        top: GLOBAL_TOP_BAR_HEIGHT,
        left: 60,
        width: 'calc(100vw - 65px)',
        height: `calc(100vh - ${GLOBAL_TOP_BAR_HEIGHT}px)`,
        backgroundColor: theme.palette.grey[100],
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
    },
    header: {
        display: 'grid',
        gridTemplateColumns: '220px minmax(0, 1fr) auto',
        alignItems: 'center',
        padding: theme.spacing(1.5, 2.5),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        background: `linear-gradient(180deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[100]} 100%)`,
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    headerWithStepper: {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr) auto',
        alignItems: 'center',
        padding: theme.spacing(0.5, 2.5),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        background: `linear-gradient(180deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[100]} 100%)`,
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        minHeight: 36,
        minWidth: 0,
    },
    backControl: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        padding: theme.spacing(0.75, 1.25),
        borderRadius: 10,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.primary,
        },
    },
    backLabel: {
        fontSize: 13,
        fontWeight: 500,
    },
    headerTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
    },
    headerTitleText: {
        fontSize: 32,
        fontWeight: 600,
        lineHeight: 1.2,
        color: theme.palette.text.primary,
    },
    closeButton: {
        justifySelf: 'end',
        color: theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.text.primary,
        },
    },
    scheduleInfoCard: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 12,
        padding: theme.spacing(1, 1.75),
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        width: '100%',
        gap: theme.spacing(2),
        minWidth: 0,
    },
    scheduleInfoCardCompact: {
        width: 'auto',
        flex: '1 1 auto',
        maxWidth: '100%',
        '& $scheduleInfoName, & $scheduleInfoDates': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 280,
        },
    },
    scheduleInfoMain: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        whiteSpace: 'nowrap',
    },
    scheduleInfoText: {
        display: 'flex',
        flexDirection: 'column',
    },
    scheduleInfoName: {
        fontSize: 20,
        fontWeight: 700,
        color: theme.palette.text.primary,
        lineHeight: 1.15,
    },
    scheduleInfoDates: {
        fontSize: 15,
        color: theme.palette.text.secondary,
        lineHeight: 1.2,
    },
    phasePillRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flexWrap: 'wrap',
    },
    phasePill: {
        height: 32,
        borderRadius: 999,
        padding: theme.spacing(0, 1.5),
        border: `1px solid ${theme.palette.grey[400]}`,
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        fontSize: 14,
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    phasePillActive: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    phaseAddPill: {
        height: 32,
        borderRadius: 999,
        padding: theme.spacing(0, 1.5),
        border: `1px dashed ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        fontSize: 14,
        fontWeight: 700,
        whiteSpace: 'nowrap',
    },
    phaseRemovePill: {
        height: 32,
        borderRadius: 999,
        padding: theme.spacing(0, 1.5),
        border: `1px dashed ${theme.palette.error.main}`,
        color: theme.palette.error.main,
        fontSize: 14,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        '&:disabled': {
            opacity: 0.4,
            cursor: 'default',
        },
    },
    phaseHelpButton: {
        height: 32,
        borderRadius: 999,
        padding: theme.spacing(0, 1.25),
        textTransform: 'none',
        fontSize: 13,
        fontWeight: 600,
        color: theme.palette.text.secondary,
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.text.primary,
        },
    },
    phaseHelpTitle: {
        fontWeight: 700,
    },
    phaseHelpIntro: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    phaseHelpList: {
        margin: 0,
        paddingLeft: theme.spacing(2.5),
        display: 'grid',
        gap: theme.spacing(0.75),
    },
    phaseHelpListItem: {
        color: theme.palette.text.primary,
        lineHeight: 1.4,
    },
    body: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    walkFlagLoading: {
        flex: 1,
        alignSelf: 'stretch',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}))

export const useScheduleMethodSelectionStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'calc(100vh - 200px)',
        maxHeight: 'calc(100vh - 150px)',
        height: '100%',
        minWidth: 500,
        maxWidth: 700,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
        marginTop: theme.spacing(5),
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[3],
        [theme.breakpoints.down('sm')]: {
            minWidth: 'auto',
            maxWidth: '90vw',
            padding: theme.spacing(2),
        },
        overflowY: 'scroll',
    },
    headerBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(3),
    },
    headerTitle: {
        fontSize: 30,
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: 24,
        },
    },
    headerCaption: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textAlign: 'center',
        maxWidth: 520,
    },
    optionsContainer: {
        display: 'flex',
        flex: 1,
        width: '100%',
        justifyContent: 'center',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    optionBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        position: 'relative',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        gap: theme.spacing(1.25),
        minHeight: 150,
        maxHeight: 150,
        width: '100%',
        maxWidth: 360,
        borderRadius: 14,
        border: `2px solid ${theme.palette.grey[300]}`,
        background: '#fff',
        transition:
            'box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease',
        cursor: 'pointer',
        '&:hover': {
            boxShadow: '0 8px 24px rgba(0,0,0,0.10)',
            transform: 'translateY(-2px)',
            borderColor: theme.palette.primary.main,
        },
    },
    optionBoxDisabled: {
        opacity: 0.55,
        cursor: 'not-allowed',
        '&:hover': {
            boxShadow: 'none',
            transform: 'none',
            borderColor: theme.palette.grey[300],
        },
    },
    optionTitle: {
        fontSize: 18,
        fontWeight: 700,
        color: theme.palette.text.primary,
        letterSpacing: 0.2,
        marginTop: theme.spacing(2),
    },
    optionDescription: {
        fontSize: 14,
        color: theme.palette.text.secondary,
        lineHeight: 1.5,
        maxWidth: 520,
        textAlign: 'center',
        margin: 0,
    },
    optionBadge: {
        position: 'absolute',
        top: theme.spacing(1),
        left: theme.spacing(1.5),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        paddingTop: 2,
        paddingBottom: 2,
        paddingLeft: 6,
        paddingRight: 6,
        borderRadius: 999,
        background:
            'linear-gradient(0deg, rgba(25,118,210,0.08), rgba(25,118,210,0.08)), #fff',
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.light}`,
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    optionBadgeText: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.main,
    },
    optionBadgeBeta: {
        background:
            'linear-gradient(0deg, rgba(245, 124, 0, 0.10), rgba(245, 124, 0, 0.10)), #fffde7',
        border: `1px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.dark,
    },
    optionBadgeBetaText: {
        color: theme.palette.warning.dark,
    },
}))

export const useStepLoriStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'calc(100vh - 200px)',
        maxHeight: 'calc(100vh - 150px)',
        height: '100%',
        minWidth: 500,
        maxWidth: 700,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[3],
        [theme.breakpoints.down('sm')]: {
            minWidth: 'auto',
            maxWidth: '90vw',
            padding: theme.spacing(2),
        },
        overflowY: 'scroll',
    },
    advancedLoriLayout: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        minHeight: 'calc(100vh - 200px)',
        maxHeight: 'calc(100vh - 150px)',
        height: '100%',
        width: '100%',
        maxWidth: 1500,
        gap: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            maxWidth: '90vw',
        },
    },
    treePanel: {
        flex: '0 0 320px',
        minWidth: 240,
        maxWidth: 360,
        height: '100%',
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[3],
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            maxWidth: '100%',
            flex: 'none',
        },
    },
    servicesPanel: {
        flex: '0 0 320px',
        minWidth: 240,
        maxWidth: 360,
        height: '100%',
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[3],
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            maxWidth: '100%',
            flex: 'none',
        },
    },
    servicesHeader: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1.5),
    },
    servicesBody: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        paddingRight: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    servicesEmpty: {
        fontSize: 13,
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
    },
    serviceGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
        paddingBottom: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        '&:last-child': {
            borderBottom: 'none',
            paddingBottom: 0,
        },
    },
    serviceName: {
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    vendorList: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.25),
    },
    vendorItem: {
        fontSize: 12,
        color: theme.palette.text.secondary,
    },
    treeHeader: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1.5),
    },
    treeBody: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        paddingRight: theme.spacing(1),
    },
    treeNode: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.25),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
    },
    treeNodeRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    treeNodeName: {
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    treeNodeUnits: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(1),
        whiteSpace: 'nowrap',
    },
    treeNodeChildren: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    chatWindow: {
        width: '100%',
        height: '100%',
        background: '#fff',
        borderRadius: 18,
        boxShadow: '0 4px 32px rgba(0,0,0,0.10)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        gap: theme.spacing(2),
    },
    advancedChatWindow: {
        flex: 1,
        minWidth: 0,
        width: 'auto',
    },
    headerRow: {
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'start',
        width: '100%',
        paddingBottom: theme.spacing(0.5),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    scheduleInfo: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: theme.spacing(0.5),
    },
    chatHeader: {
        fontSize: 28,
        fontWeight: 600,
        textAlign: 'center',
        justifySelf: 'center',
    },
    chatMessages: {
        flex: 1,
        width: '100%',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        whiteSpace: 'pre-line',
        minHeight: 0,
        padding: theme.spacing(1, 3, 2, 3),
    },
    welcomeCard: {
        width: '100%',
        borderRadius: 16,
        border: `1px solid ${theme.palette.primary.light}`,
        background: '#fff',
        padding: theme.spacing(2.5, 3),
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        marginBottom: theme.spacing(2),
    },
    welcomeTitle: {
        fontWeight: 600,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(0.5),
    },
    welcomeSubtitle: {
        color: theme.palette.text.primary,
        fontWeight: 500,
    },
    welcomeList: {
        marginTop: theme.spacing(1),
        paddingLeft: theme.spacing(2.5),
        display: 'grid',
        gap: theme.spacing(1.5),
    },
    welcomeListItem: {
        listStyleType: 'disc',
    },
    welcomeListHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
    },
    welcomeLabel: {
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    welcomeOptional: {
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        color: theme.palette.warning.dark,
        background: theme.palette.warning.light,
        padding: theme.spacing(0.25, 1),
        borderRadius: 999,
    },
    welcomeDescription: {
        color: theme.palette.text.secondary,
    },
    footerContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.spacing(0.5),
    },
    hiddenDatePicker: {
        display: 'none',
    },
    chatInputRow: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        marginTop: 'auto',
        flex: 'none',
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        background: '#fff',
    },
    inputButtons: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.25),
        justifyContent: 'flex-end',
    },
    input: {
        flex: 1,
        background: theme.palette.grey[100],
        borderRadius: 24,
    },
    inputRoot: {
        borderRadius: 24,
        background: theme.palette.grey[100],
    },
    userMsg: {
        alignSelf: 'flex-end',
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderRadius: 18,
        padding: theme.spacing(1.2, 2),
        maxWidth: '70%',
        wordBreak: 'break-word',
    },
    botMsg: {
        alignSelf: 'flex-start',
        background: theme.palette.grey[100],
        color: theme.palette.text.primary,
        borderRadius: 18,
        padding: theme.spacing(1.2, 2),
        maxWidth: '70%',
        wordBreak: 'break-word',
    },
    inlineSelectorButton: {
        display: 'flex',
        marginTop: theme.spacing(1),
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 12,
        fontSize: 13,
        padding: theme.spacing(0.75, 2),
    },
    connecting: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: theme.palette.text.secondary,
        justifyContent: 'center',
        width: '100%',
        marginTop: theme.spacing(2),
    },
    chatStyleButton: {
        background: '#fff',
        color: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.main}`,
        fontWeight: 600,
        minWidth: 160,
        fontSize: 18,
        transition: 'background 0.2s, color 0.2s',
        boxShadow: 'none',
        '&:hover': {
            background: theme.palette.primary.dark,
            color: '#fff',
            borderColor: theme.palette.primary.dark,
        },
    },
    buildTurnProjectButton: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        border: `2px solid ${theme.palette.primary.main}`,
        fontWeight: 600,
        minWidth: 240,
        maxWidth: 240,
        fontSize: 18,
        textTransform: 'none',
        transition: 'background 0.2s, color 0.2s',
        boxShadow: 'none',
        '&:hover': {
            background: theme.palette.primary.dark,
            color: '#fff',
            borderColor: theme.palette.primary.dark,
        },
    },
    micPulse: {
        position: 'absolute',
        width: 48,
        height: 48,
        borderRadius: '50%',
        background: 'rgba(255,0,0,0.2)',
        boxShadow: '0 0 0 0 rgba(255,0,0,0.7)',
        animation: '$pulse 1.2s infinite',
        zIndex: 0,
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    dialogContent: {
        minHeight: 400,
    },
    '@keyframes pulse': {
        '0%': { transform: 'scale(1)', opacity: 1 },
        '70%': { transform: 'scale(1.5)', opacity: 0.3 },
        '100%': { transform: 'scale(2)', opacity: 0 },
    },
}))

export const useScheduleReviewStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: '100%',
        height: '100%',
        minHeight: 0,
    },
    body: {
        flex: 1,
        minHeight: 0,
        width: '100%',
        overflow: 'hidden',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        marginBottom: theme.spacing(2),
    },
    header: {
        display: 'flex',
        height: 60,
        borderTop: `2px solid ${theme.palette.divider}`,
        borderBottom: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(2),
        alignItems: 'stretch',
        gap: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    headerCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
        flex: 1,
    },
    headerRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginLeft: 'auto',
    },
    infoPanel: {
        width: '100%',
        height: '100%',
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.grey[50],
        padding: theme.spacing(1, 2),
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        overflowY: 'auto',
        display: 'flex',
        alignItems: 'center',
    },
    errorPanelRoot: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    errorPanelContent: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        minWidth: 0,
        height: '100%',
    },
    errorPanelSuccessText: {
        fontWeight: 600,
    },
    errorPanelWarningText: {
        fontWeight: 600,
        color: theme.palette.error.main,
    },
    errorPanelLeftRail: {
        width: 165,
        minWidth: 165,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(0.25),
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        paddingRight: theme.spacing(1.25),
        height: '100%',
    },
    errorPanelTitle: {
        fontWeight: 700,
        lineHeight: 1.2,
        marginBottom: 0,
    },
    errorPanelMessagePane: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
    },
    errorPanelMessage: {
        fontWeight: 500,
        lineHeight: 1.2,
        whiteSpace: 'normal',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },
    errorPanelPagerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
    },
    errorPanelPagerIndex: {
        color: theme.palette.text.secondary,
        fontWeight: 600,
        minWidth: 40,
        textAlign: 'center',
    },
    errorPanelPagerArrow: {
        padding: 4,
    },
    infoList: {
        margin: 0,
        paddingLeft: theme.spacing(3),
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(2),
        listStyleType: 'disc',
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    infoListItem: {
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
    },
    helpButton: {
        textTransform: 'none',
        minWidth: 160,
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary,
        border: `2px solid ${theme.palette.primary.main}`,
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        },
        marginLeft: theme.spacing(1),
        fontSize: 16,
    },
    primaryCtaButton: {
        textTransform: 'none',
        minWidth: 250,
        fontSize: 16,
        fontWeight: 700,
        boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
        '&:hover': {
            boxShadow: '0 8px 22px rgba(0,0,0,0.22)',
        },
        marginRight: theme.spacing(2),
    },
    primaryCtaButtonLoading: {
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.common.white,
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[600],
            color: theme.palette.common.white,
            opacity: 1,
        },
        '&:hover': {
            backgroundColor: theme.palette.grey[700],
        },
    },
    primaryCtaSpinner: {
        color: theme.palette.common.white,
    },
    scheduleWorkordersButton: {
        textTransform: 'none',
        width: 290,
    },
    dialogCancelButton: {
        marginRight: theme.spacing(2),
        textTransform: 'none',
    },
    dialogSubmitButton: {
        marginRight: theme.spacing(2),
        width: 120,
        textTransform: 'none',
    },
    dialogItalicText: {
        fontStyle: 'italic',
    },
}))

export const useLoriReviewStyles = makeStyles((theme: Theme) => ({
    root: {
        alignSelf: 'flex-start',
        background: theme.palette.grey[100],
        color: theme.palette.text.primary,
        borderRadius: 18,
        padding: theme.spacing(2),
        maxWidth: '85%',
        width: '100%',
    },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1.5),
    },
    header: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    proceedButton: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 600,
        fontSize: 12,
        textTransform: 'none',
        padding: theme.spacing(0.5, 1.5),
        borderRadius: 8,
        '&:hover': {
            background: theme.palette.primary.dark,
        },
    },
    section: {
        marginBottom: theme.spacing(1.5),
    },
    sectionHeader: {
        fontSize: 13,
        fontWeight: 600,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
        textTransform: 'uppercase',
        letterSpacing: 0.5,
    },
    dateRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
    },
    dateLabel: {
        fontSize: 13,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        minWidth: 80,
    },
    dateValue: {
        fontSize: 13,
        fontWeight: 500,
        color: theme.palette.text.primary,
    },
    chipContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(0.5),
    },
    unitChip: {
        height: 24,
        fontSize: 12,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.grey[300]}`,
    },
    serviceRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.25),
        marginBottom: theme.spacing(1),
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    serviceName: {
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    vendorList: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(1),
    },
    divider: {
        margin: theme.spacing(1.5, 0),
    },
    accordion: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
    },
    accordionSummary: {
        padding: 0,
        minHeight: 'unset',
        '&.Mui-expanded': {
            minHeight: 'unset',
        },
        '& .MuiAccordionSummary-content': {
            margin: 0,
            '&.Mui-expanded': {
                margin: 0,
            },
        },
        '& .MuiAccordionSummary-expandIcon': {
            padding: theme.spacing(0.5),
        },
    },
    accordionDetails: {
        padding: theme.spacing(1, 0, 0, 0),
    },
    folderTree: {
        display: 'flex',
        flexDirection: 'column' as const,
        maxHeight: 250,
        overflowY: 'auto' as const,
    },
    folderRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: theme.spacing(1),
        padding: theme.spacing(0.25, 0),
    },
    folderBranchName: {
        fontSize: 13,
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    folderLeafName: {
        fontSize: 13,
        fontWeight: 500,
        color: theme.palette.text.primary,
    },
    folderUnitCount: {
        fontSize: 12,
        fontWeight: 400,
        color: theme.palette.text.secondary,
    },
    folderLeafRow: {
        display: 'flex',
        flexWrap: 'wrap' as const,
        gap: theme.spacing(0.5, 1.5),
    },
}))

export const useExistingDataGateStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        padding: theme.spacing(4),
    },
    card: {
        width: '100%',
        maxWidth: 420,
        borderRadius: 16,
        border: `1px solid ${theme.palette.primary.light}`,
        background: '#fff',
        padding: theme.spacing(3, 4),
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        textAlign: 'center' as const,
    },
    title: {
        fontWeight: 600,
        fontSize: 20,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    subtitle: {
        color: theme.palette.text.secondary,
        fontSize: 18,
        marginBottom: theme.spacing(3),
    },
    actions: {
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'center',
    },
    resetButton: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 600,
        fontSize: 17,
        textTransform: 'none' as const,
        padding: theme.spacing(1, 3),
        borderRadius: 8,
        '&:hover': {
            background: theme.palette.primary.dark,
        },
    },
    exitButton: {
        fontWeight: 600,
        fontSize: 17,
        textTransform: 'none' as const,
        padding: theme.spacing(1, 3),
        borderRadius: 8,
        color: theme.palette.text.secondary,
        border: `1px solid ${theme.palette.divider}`,
    },
}))

export const useTemplateSchedulesStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(2),
        background: theme.palette.grey[100],
        borderRadius: 18,
        padding: theme.spacing(2),
        width: '100%',
    },
    header: {
        fontSize: 15,
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1.5),
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    accordion: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 14,
        boxShadow: theme.shadows[1],
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
    },
    accordionSummary: {
        padding: theme.spacing(1.5, 2),
        '& .MuiAccordionSummary-content': {
            margin: 0,
        },
    },
    accordionDetails: {
        padding: theme.spacing(0, 2, 2, 2),
    },
    summaryContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75),
        width: '100%',
    },
    summaryHeaderRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
    },
    summaryNameRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        flexWrap: 'wrap',
    },
    scheduleName: {
        fontSize: 15,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    useTemplateButton: {
        textTransform: 'none',
        fontSize: 12,
        fontWeight: 600,
        borderRadius: 8,
    },
    dateRange: {
        fontSize: 12,
        color: theme.palette.text.primary,
        fontWeight: 500,
    },
    metaRow: {
        display: 'flex',
        gap: theme.spacing(2),
    },
    metaItem: {
        fontSize: 12,
        color: theme.palette.text.secondary,
    },
    detailsColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%',
    },
    detailSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    detailHeader: {
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
    },
    servicesList: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    serviceCard: {
        padding: theme.spacing(1),
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: theme.palette.grey[50],
    },
    serviceName: {
        fontSize: 13,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    vendorList: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5),
    },
    detailEmpty: {
        fontSize: 12,
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2),
    },
    stateContainer: {
        padding: theme.spacing(2),
    },
    stateText: {
        fontSize: 13,
        color: theme.palette.text.secondary,
        textAlign: 'center',
    },
}))

export const useAutoScheduleStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%',
        minWidth: '90vw',
        maxWidth: '95vw',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[3],
        [theme.breakpoints.down('sm')]: {
            minWidth: 'auto',
            maxWidth: '95vw',
            padding: theme.spacing(2),
        },
        overflow: 'hidden',
    },
    loadingContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    gridContainer: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flex: '1 1 0px',
        minHeight: 0,
        overflow: 'hidden',
    },
    unitSelectionPanel: {
        flexDirection: 'column',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2),
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        height: '100%',
        display: 'flex',
        flex: 1,
        minHeight: 0,
    },
    configPanel: {
        flexDirection: 'column',
        flex: '1 1 0px',
        height: '100%',
        width: '100%',
        marginLeft: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        minHeight: 0,
    },
    configTopGrid: {
        marginBottom: theme.spacing(2),
    },
    headerControlsRow: {
        display: 'flex',
        alignItems: 'stretch',
        gap: theme.spacing(1.5),
        width: '100%',
        flexWrap: 'nowrap',
        minWidth: 0,
    },
    headerDateGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75),
        minWidth: 0,
        flex: '1 1 0',
    },
    headerSectionCard: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0.75, 1.25),
    },
    headerSectionTitle: {
        fontWeight: 700,
        fontSize: '0.9rem',
        lineHeight: '32px',
        margin: theme.spacing(1),
    },
    headerCaptionText: {
        fontSize: '0.8rem',
        lineHeight: 1.35,
        color: theme.palette.text.secondary,
        margin: theme.spacing(-2, 1, 0, 1),
    },
    headerDateStack: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        minWidth: 0,
        marginTop: 'auto',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
    },
    headerDateField: {
        width: '100%',
        minWidth: 0,
    },
    workspaceRulesGroup: {
        width: 300,
        flex: '0 0 300px',
        display: 'flex',
        flexDirection: 'column',
    },
    proceedButtonGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        width: 'max-content',
        marginLeft: 'auto',
        paddingTop: 0,
        gap: theme.spacing(1),
    },
    proceedViolationsCard: {
        width: '100%',
        padding: theme.spacing(1.25, 1.5),
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.warning.light}`,
        backgroundColor: theme.palette.warning.main + '12',
    },
    proceedViolationsTitle: {
        fontSize: '0.8rem',
        fontWeight: 700,
        marginBottom: theme.spacing(0.5),
        color: theme.palette.text.primary,
    },
    proceedViolationsList: {
        margin: 0,
        paddingLeft: 0,
        listStylePosition: 'inside',
        textAlign: 'left',
    },
    proceedViolationsItem: {
        fontSize: '0.78rem',
        lineHeight: 1.45,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
    },
    timelineGridItem: {
        display: 'flex',
        flexDirection: 'column',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        paddingRight: theme.spacing(2),
        justifyContent: 'flex-end',
        alignItems: 'center',
        merginBottom: theme.spacing(5),
    },
    areaRulesGridItem: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        paddingLeft: theme.spacing(2),
        justifyContent: 'flex-start',
    },
    proceedButtonRow: {
        display: 'flex',
        flex: '0 0 auto',
        justifyContent: 'flex-end',
        width: '100%',
        marginBottom: theme.spacing(0.5),
    },
    areaRuleSection: {
        marginBottom: 0,
        flexDirection: 'column',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1.25, 1.5),
        gap: theme.spacing(0.75),
    },
    areaRuleLabel: {
        fontWeight: 700,
        marginBottom: theme.spacing(0.5),
        fontSize: '0.95rem',
    },
    areaRuleOptions: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& .MuiFormControlLabel-label': {
            fontSize: '0.9rem',
            lineHeight: 1.35,
        },
    },
    areaRuleHeader: {
        fontWeight: 700,
        marginBottom: theme.spacing(0.5),
        fontSize: '0.95rem',
    },
    areaRuleSummaryRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
    },
    areaRuleSummaryLabel: {
        fontSize: '0.85rem',
        color: theme.palette.text.secondary,
    },
    areaRuleSummaryValue: {
        fontSize: '0.9rem',
        fontWeight: 600,
    },
    editRulesButton: {
        textTransform: 'none',
        alignSelf: 'flex-end',
        marginTop: theme.spacing(0.5),
        minHeight: 30,
    },
    rulesDialogIntroText: {
        marginBottom: theme.spacing(0.75),
    },
    rulesDialogGroup: {
        marginTop: theme.spacing(1.5),
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    rulesDialogGroupTitle: {
        fontWeight: 700,
        marginBottom: theme.spacing(0.5),
    },
    rulesDialogFormControl: {
        width: '100%',
        '& .MuiFormControlLabel-label': {
            fontSize: '0.9rem',
            lineHeight: 1.35,
        },
    },
    rulesDialogSectionHeader: {
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: theme.spacing(0.75),
        fontSize: '1.05rem',
    },
    rulesDialogOptionRow: {
        alignItems: 'flex-start',
        marginTop: theme.spacing(0.25),
        marginBottom: theme.spacing(0.25),
    },
    rulesDialogOptionLabelWrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    rulesDialogOptionLabel: {
        fontWeight: 700,
        fontSize: '1rem',
        lineHeight: 1.2,
    },
    rulesDialogOptionDescription: {
        fontSize: '0.82rem',
        lineHeight: 1.3,
        color: theme.palette.text.secondary,
    },
    sectionTitle: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2),
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    unitCountText: {
        marginLeft: theme.spacing(3),
    },
    timelineHeader: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginTop: 0,
        marginBottom: theme.spacing(1),
        textAlign: 'center',
    },
    ruleHeader: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    ruleContainer: {
        padding: theme.spacing(2),
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(4),
    },
    ruleFormControl: {
        flex: 1,
        marginLeft: theme.spacing(14),
    },
    ruleFormControlCentered: {
        flex: 1,
        alignItems: 'center',
    },
    dateContainer: {
        padding: theme.spacing(1, 2),
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(2),
        flexDirection: 'column',
    },
    dateRow: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        gap: theme.spacing(2),
    },
    serviceContainer: {
        flexDirection: 'column',
        width: '100%',
        flex: '1 1 0px',
        height: 0,
        minHeight: 0,
        display: 'flex',
        overflow: 'hidden',
        borderTop: `1px solid ${theme.palette.grey[300]}`,
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    servicesScrollContainer: {
        flex: '1 1 0px',
        height: 0,
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        minHeight: 0,
        paddingBottom: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    serviceTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexShrink: 0,
        gap: theme.spacing(2),
        width: '100%',
    },
    addServiceButton: {
        textTransform: 'none',
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[400],
            color: theme.palette.grey[700],
            opacity: 1,
        },
        backgroundColor: theme.palette.primary.main,
        maxHeight: 32,
        maxWidth: 120,
        marginTop: theme.spacing(2),
    },
    editRulesPrimaryButton: {
        textTransform: 'none',
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
        backgroundColor: theme.palette.primary.main,
        height: 32,
        minWidth: 112,
        borderColor: theme.palette.primary.main,
    },
    addServiceIcon: {
        marginRight: theme.spacing(1),
    },
    addServiceText: {
        fontWeight: 500,
    },
    droppableArea: {
        width: '100%',
        backgroundColor: 'white',
    },
    footer: {
        padding: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minHeight: 60,
    },
    proceedButton: {
        textTransform: 'none',
        width: '100%',
        whiteSpace: 'nowrap',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
        '&:disabled': {
            backgroundColor: theme.palette.grey[400],
            color: theme.palette.primary.contrastText,
        },
    },
    templateVendorBox: {
        marginLeft: theme.spacing(6),
        backgroundColor: theme.palette.grey[50],
        border: `1px solid ${theme.palette.grey[300]}`,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        padding: theme.spacing(1.5, 2),
        borderRadius: theme.shape.borderRadius,
        margin: theme.spacing(1.5, 0),
        width: 'calc(100% - 48px)',
        maxWidth: 'calc(100% - 48px)',
        minWidth: 0,
        boxSizing: 'border-box',
        height: 42,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        transition: 'box-shadow 0.2s ease, background-color 0.2s ease',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
        },
    },
    walkVendorBox: {
        height: 'auto',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    walkVendorDate: {
        width: 150,
    },
    templateVendorName: {
        fontSize: 18,
        fontWeight: 600,
        color: theme.palette.text.primary,
        letterSpacing: 0.2,
        alignSelf: 'center',
        marginLeft: theme.spacing(2),
    },
    templateServiceDraggable: {
        display: 'flex',
        padding: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        userSelect: 'none',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
    },
    templateServiceContainer: {
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.grey[400]}`,
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(6),
        width: '100%',
        boxSizing: 'border-box',
        flexDirection: 'column',
        overflow: 'visible',
        flexShrink: 0,
    },
    walkSetupRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        gap: theme.spacing(3),
        width: '100%',
        minHeight: 0,
        flex: 1,
    },
    walkPhoneColumn: {
        width: 380,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
    },
    walkSetup: {
        width: '100%',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        flex: 1,
        gap: theme.spacing(3),
        padding: theme.spacing(3, 4),
        boxSizing: 'border-box',
    },
    walkSetupTitle: {
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    walkServiceHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        width: '100%',
        flexShrink: 0,
    },
    walkServiceTitle: {
        fontWeight: 700,
        color: theme.palette.text.primary,
        margin: 0,
    },
    walkAddServiceButton: {
        marginTop: 0,
    },
    walkEmptyCopy: {
        textAlign: 'center',
        maxWidth: 520,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    walkFlow: {
        flex: 1,
        alignSelf: 'stretch',
        width: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    walkFlowBody: {
        flex: 1,
        minHeight: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    headerStepper: {
        width: 440,
        maxWidth: '100%',
        backgroundColor: 'transparent',
        pointerEvents: 'none',
        '&.MuiStepper-root': {
            padding: theme.spacing(0.5, 0),
        },
    },
    walkSummaryService: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1.25, 0),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    walkSummaryName: {
        fontWeight: 600,
    },
    walkUnitList: {
        width: '100%',
        maxHeight: 240,
        overflowY: 'auto',
    },
    serviceBudgetInput: {
        width: 180,
        marginLeft: theme.spacing(2),
        '& .MuiOutlinedInput-input': {
            paddingTop: 10.5,
            paddingBottom: 10.5,
        },
        '& .MuiInputLabel-outlined': {
            transform: 'translate(14px, 12px) scale(1)',
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75)',
        },
    },
}))

export const useTurnReviewDialogStyles = makeStyles((theme: Theme) => ({
    paper: {
        minWidth: 'calc(100vw - 100px)',
        maxWidth: 'calc(100vw - 100px)',
        minHeight: 'calc(100vh - 100px)',
        maxHeight: 'calc(100vh - 100px)',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        minHeight: 360,
    },
    reviewTitleRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1.5),
    },
    reviewPhasePillRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        overflowX: 'auto',
        maxWidth: '70%',
    },
    reviewPhasePill: {
        height: 30,
        borderRadius: 999,
        padding: theme.spacing(0, 1.5),
        border: `1px solid ${theme.palette.grey[400]}`,
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        fontSize: 13,
        fontWeight: 600,
        whiteSpace: 'nowrap',
    },
    reviewPhasePillActive: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    statsRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
        gap: theme.spacing(1.5),
    },
    statTile: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.grey[50],
        padding: theme.spacing(1.25, 1.5),
    },
    statLabel: {
        fontSize: 16,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
    },
    statValue: {
        fontSize: 32,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    statSecondaryValue: {
        marginTop: theme.spacing(0.5),
        fontSize: 16,
        color: theme.palette.text.secondary,
    },
    tabsContainer: {
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        flex: 1,
        minHeight: 0,
    },
    tabPanel: {
        padding: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.grey[300]}`,
        flex: 1,
        overflow: 'auto',
    },
    panelStack: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    sectionTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    servicesSectionTitle: {
        fontSize: 20,
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    serviceCardsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
        gap: theme.spacing(1.5),
    },
    serviceCard: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius * 2,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1.5, 2),
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    serviceCardHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.25),
        paddingBottom: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    serviceCardIcon: {
        width: 28,
        height: 28,
        objectFit: 'contain',
        flexShrink: 0,
    },
    serviceCardName: {
        fontSize: 15,
        fontWeight: 700,
        color: theme.palette.text.primary,
        flex: 1,
        minWidth: 0,
    },
    serviceCardTotal: {
        fontSize: 14,
        fontWeight: 700,
        color: theme.palette.text.primary,
        flexShrink: 0,
    },
    serviceCardVendorTable: {
        display: 'grid',
        gridTemplateColumns: '1fr auto auto auto',
        columnGap: theme.spacing(2),
        rowGap: theme.spacing(0.25),
        alignItems: 'center',
        fontSize: 13,
    },
    serviceCardVendorRow: {
        display: 'contents',
    },
    serviceCardVendorName: {
        color: theme.palette.text.primary,
        fontWeight: 600,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    serviceCardVendorCount: {
        fontWeight: 600,
        color: theme.palette.text.primary,
        textAlign: 'right',
        minWidth: 32,
    },
    serviceCardVendorStat: {
        textAlign: 'right',
        color: theme.palette.text.secondary,
        fontSize: 12,
        whiteSpace: 'nowrap',
        '& strong': {
            fontWeight: 700,
            color: theme.palette.text.primary,
            fontSize: 13,
        },
    },
    vendorTableScroll: {
        overflowX: 'auto',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
    },
    vendorTableGrid: {
        minWidth: 1260,
        display: 'flex',
        flexDirection: 'column',
    },
    vendorTableGroupHeaderRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
        backgroundColor: theme.palette.grey[100],
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    vendorTableSubHeaderRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
        backgroundColor: theme.palette.grey[50],
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    vendorHeaderCell: {
        padding: theme.spacing(1),
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        '&:last-child': {
            borderRight: 'none',
        },
    },
    vendorHeaderThroughputGroup: {
        gridColumn: '5 / span 4',
        padding: theme.spacing(1),
        fontSize: 13,
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: 'center',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        borderLeft: `1px solid ${theme.palette.grey[300]}`,
    },
    vendorHeaderFinancialGroup: {
        gridColumn: '9 / span 4',
        padding: theme.spacing(1),
        fontSize: 13,
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: 'center',
    },
    vendorBodyRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    vendorTotalRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
        borderBottom: `2px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.grey[100],
    },
    vendorBodyCell: {
        padding: theme.spacing(1),
        fontSize: 12,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '&:last-child': {
            borderRight: 'none',
        },
    },
    vendorTotalCell: {
        padding: theme.spacing(1),
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '&:last-child': {
            borderRight: 'none',
        },
    },
    vendorTableEmptyRow: {
        padding: theme.spacing(1.5),
    },
    vendorGroupContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    phaseSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    unitCoverageAllPhasesTables: {
        display: 'flex',
        gap: theme.spacing(1.5),
        alignItems: 'flex-start',
        overflowX: 'auto',
        overflowY: 'hidden',
        paddingBottom: theme.spacing(0.5),
    },
    unitCoverageAllPhaseSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        flex: '0 0 460px',
        minWidth: 460,
        maxWidth: 460,
    },
    unitCoverageAllPhaseTableScroll: {
        maxHeight: 420,
        minHeight: 240,
    },
    phaseSectionTitle: {
        fontSize: 14,
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    tableWrap: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
    },
    tableHeaderRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        backgroundColor: theme.palette.grey[100],
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    tableHeaderCell: {
        padding: theme.spacing(1),
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    tableBodyRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    tableCell: {
        padding: theme.spacing(1),
        fontSize: 12,
        color: theme.palette.text.primary,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    emptyStateText: {
        padding: theme.spacing(1.5),
        fontSize: 12,
        color: theme.palette.text.secondary,
    },
    unitCoverageSplitLayout: {
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'stretch',
        flex: 1,
        minHeight: 0,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
    },
    unitCoverageLeftPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        flex: '0 0 200px',
        minWidth: 200,
        maxWidth: 200,
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
            minWidth: 0,
            flex: '1 1 auto',
        },
    },
    unitCoverageRightPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        flex: 1,
        minWidth: 0,
        minHeight: 0,
    },
    unitCoverageFilterCard: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.grey[50],
        padding: theme.spacing(1.5),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    unitCoverageFilterGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: theme.spacing(1),
    },
    unitCoverageStatsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: theme.spacing(1),
    },
    unitCoverageResultsCount: {
        fontSize: 12,
        fontWeight: 500,
        color: theme.palette.text.secondary,
    },
    unitCoverageResultsRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
    },
    clearFiltersButton: {
        minWidth: 'auto',
        padding: 0,
        textTransform: 'none',
        fontSize: 12,
    },
    unitCoverageTableScroll: {
        overflow: 'auto',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        flex: 1,
        minHeight: 0,
    },
    unitCoverageTableGrid: {
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
    },
    unitCoverageHeaderRow: {
        display: 'grid',
        backgroundColor: theme.palette.grey[100],
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        position: 'sticky',
        top: 0,
        zIndex: 1,
    },
    unitCoverageHeaderCell: {
        padding: theme.spacing(1),
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        '&:last-child': {
            borderRight: 'none',
        },
    },
    unitCoverageBodyRow: {
        display: 'grid',
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    unitCoverageBodyCell: {
        padding: theme.spacing(1),
        fontSize: 12,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        '&:last-child': {
            borderRight: 'none',
        },
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    unitCoverageBodyCellWithPadding: {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(1.5),
        fontSize: 12,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.grey[200]}`,
        '&:last-child': {
            borderRight: 'none',
        },
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}))

export const useDuplicateTurnWizardStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        padding: theme.spacing(3, 2),
    },
    card: {
        width: '100%',
        maxWidth: 720,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 16,
        border: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
    },
    title: {
        fontSize: 24,
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    subtitle: {
        fontSize: 14,
        color: theme.palette.text.secondary,
        lineHeight: 1.5,
    },
    stepLabel: {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        color: theme.palette.text.secondary,
    },
    sourceList: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        maxHeight: 420,
        overflowY: 'auto',
    },
    sourceRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        textAlign: 'left',
        gap: theme.spacing(0.5),
        width: '100%',
        padding: theme.spacing(1.75, 2),
        borderRadius: 12,
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: '#fff',
        cursor: 'pointer',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        '&:hover': {
            borderColor: theme.palette.primary.main,
            boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        },
    },
    sourceRowSelected: {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
    },
    sourceName: {
        fontSize: 16,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    sourceMeta: {
        fontSize: 13,
        color: theme.palette.text.secondary,
    },
    phaseBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2),
        borderRadius: 12,
        border: `1px solid ${theme.palette.grey[200]}`,
        backgroundColor: theme.palette.grey[50],
    },
    phaseTitleRow: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    phaseTitle: {
        fontSize: 15,
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    dateRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: '1fr',
        },
    },
    dayCountHint: {
        fontSize: 13,
        color: theme.palette.text.secondary,
        textAlign: 'right' as const,
        flex: '1 1 auto',
    },
    dayCountWarning: {
        color: theme.palette.warning.dark,
        fontWeight: 600,
    },
    sectionTitle: {
        fontSize: 15,
        fontWeight: 600,
        color: theme.palette.text.primary,
        marginTop: theme.spacing(1),
    },
    budgetHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        marginTop: theme.spacing(1),
        '& $sectionTitle': {
            marginTop: 0,
        },
    },
    clearBudgetsButton: {
        textTransform: 'none' as const,
        fontWeight: 600,
        fontSize: 13,
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(1),
    },
    primaryButton: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        padding: theme.spacing(1, 2.5),
    },
    secondaryButton: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
    },
    errorText: {
        color: theme.palette.error.main,
        fontSize: 13,
    },
    warningBanner: {
        padding: theme.spacing(1.5, 2),
        borderRadius: 10,
        backgroundColor: 'rgba(245, 124, 0, 0.08)',
        border: `1px solid ${theme.palette.warning.light}`,
        color: theme.palette.warning.dark,
        fontSize: 13,
        lineHeight: 1.45,
    },
    overwriteWarningBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2, 2.25),
        borderRadius: 12,
        backgroundColor: 'rgba(230, 81, 0, 0.12)',
        border: `2px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.dark,
        boxShadow: '0 2px 8px rgba(230, 81, 0, 0.18)',
    },
    overwriteWarningIcon: {
        color: theme.palette.warning.dark,
        fontSize: 28,
        marginTop: 2,
        flexShrink: 0,
    },
    overwriteWarningBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
        minWidth: 0,
    },
    overwriteWarningTitle: {
        fontSize: 15,
        fontWeight: 800,
        letterSpacing: 0.2,
        textTransform: 'uppercase' as const,
        color: theme.palette.warning.dark,
        lineHeight: 1.3,
    },
    overwriteWarningText: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1.45,
        color: theme.palette.warning.dark,
    },
    budgetRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
    },
    budgetLabel: {
        fontSize: 14,
        color: theme.palette.text.primary,
        flex: 1,
    },
    budgetInput: {
        width: 140,
    },
    subRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        padding: theme.spacing(1.5),
        borderRadius: 10,
        border: `1px solid ${theme.palette.grey[200]}`,
    },
}))
